export default class Provider {
  boot() {}
}
